import React from "react";
import { PurposedButtonProps } from "./types";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";

const GreenNoIconButton = (props: PurposedButtonProps) => {
  const { colors } = useTheme();
  return (
    <EwaButton2 buttonColor={colors.save} label={props.label} {...props} />
  );
};

export default GreenNoIconButton;
